import { param } from "jquery";
import requests, { setToken } from "./httpServices";
import { Loader } from "react-feather";

const QuizServices = {
  completeProcess: async (teacher_id = null) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);
      const userId = teacher_id || JSON.parse(localStorage.getItem("user"))._id;
      const params = {
        role: teacher_id ? 2 : 1,
        userId,
      };
      const response = await requests.post("/quiz/complete", params);
      return response;
    } catch (error) {
      console.error("Error in quiz complete api:", error);
      throw error;
    }
  },

  saveProcess: async (
    currentGroupIndex,
    currentVideoIndex,
    teacherId = null
  ) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const userId = teacherId || JSON.parse(localStorage.getItem("user"))._id;

      const params = {
        role: teacherId ? 2 : 1,
        userId,
        currentGroupIndex,
        currentVideoIndex,
      };

      const response = await requests.put("/quiz/save-process", params);
      return response;
    } catch (error) {
      console.error("Error in quiz complete api:", error);
      throw error;
    }
  },

  checkProcess: async (teacherId = null) => {
    try {
      const token = localStorage.getItem("token"); // Get token 0from localStorage
      setToken(token);
      const userId = teacherId || JSON.parse(localStorage.getItem("user"))._id;
      const params = { role: teacherId ? 2 : 1, userId };
      const response = await requests.post("/quiz/check-process", params);
      return response;
    } catch (error) {
      console.error("Error in Getting Quiz Process:", error);
      throw error;
    }
  },

  getProcess: async (teacherId, role) => {
    try {
      const token = localStorage.getItem("token"); // Get token 0from localStorage
      setToken(token);
      const response = await requests.get("/quiz/get-process", {
        params: { teacherId, role },
      });
      return response;
    } catch (error) {
      console.error("Error in Getting Quiz Process:", error);
      throw error;
    }
  },
};

export default QuizServices;
